/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { 
    selectDrivers
} from '../features/drivers/driversSlice'
import {
    addRota,
    selectRotaData
} from '../features/rota/rotaSlice'

const GetSchedule = (props) => {
    // function for getting the week
    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    // allow for dispatching
    const dispatch = useDispatch();

    // set the current date
    const [ currentDate ] = useState(new Date())

    // grab redux drivers
    const reduxDrivers = useSelector(selectDrivers)
    const rotaData = useSelector(selectRotaData)

    // api functions
    var CryptoJS = require("crypto-js");
    async function postData(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });
        return response ? response.json() : console.log('no reponse')
    };
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
        });
        return response ? response.json() : console.log('no reponse')
    };

    // for grabbing all of the dates
    useEffect( () => {
        if (props.allGate) {
            if (reduxDrivers.length > 0) {
                let driverArray = [...reduxDrivers]
                    for (let i = -21; i < 10; i++) {
                        let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)
                            if (dateInner.getDay() === 0) {
                                let theDateWeek = new Date(dateInner).getWeek()
                            postData('https://backendpajamas.herokuapp.com/weeksschedule/', {
                                date: dateInner.toDateString(),
                                week: theDateWeek
                            }).then( response => {
                                let finalBottomArray = []
                                let finalObj = {
                                    'DBS2': [],
                                    'DCF1': [],
                                    'DRR1': [],
                                    'DEX2': [],
                                    'DXP1': [],
                                    'DSN1': []
                                }
                                response.data.forEach( date => {
                                    if (date.name === 'bottomRoutes') {
                                        finalBottomArray.push(date)
                                    } else {
                                        driverArray.forEach( (driver, driverId) => {
                                            if (driver.driver_id === parseInt(date.driver_id.match(/\d+/g)[0])) {
                                                if (driver.datesList) {
                                                    let localDriver = {...driver}
                                                    localDriver.datesList = [...localDriver.datesList, date]
                                                    driverArray[driverId] = localDriver
                                                } else {
                                                    driver.datesList = [date]
                                                }
                                            }
                                        })
                                    }
                                })
                                driverArray.forEach( driver => {
                                    finalObj[driver.location].push(driver)
                                })
                                let name = dateInner.toDateString()
                                let myObj = {}
                                myObj[`${name}`] = {
                                    'bottomArray': finalBottomArray,
                                    'drivers': finalObj
                                }
                                dispatch(addRota({
                                    payload: myObj[`${name}`],
                                    name: `${name}`
                                }))
                            })
                        }
                    }
            } else {
                getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
                    let driverArray = response.results
                    for (let i = -21; i < 10; i++) {
                        let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)

                        if (dateInner.getDay() === 0) {
                            let theDateWeek = new Date(dateInner).getWeek()
                            postData('https://backendpajamas.herokuapp.com/weeksschedule/', {
                                date: dateInner.toDateString(),
                                week: theDateWeek
                            }).then( response => {
                                let finalBottomArray = []
                                let finalObj = {
                                    'DBS2': [],
                                    'DCF1': [],
                                    'DRR1': [],
                                    'DEX2': [],
                                    'DXP1': [],
                                    'DSN1': []
                                }
                                response.data.forEach( date => {
                                    if (date.name === 'bottomRoutes') {
                                        finalBottomArray.push(date)
                                    } else {
                                        driverArray.forEach( driver => {
                                            if (driver.driver_id === parseInt(date.driver_id.match(/\d+/g)[0])) {
                                                if (driver.datesList) {
                                                    driver.datesList = [...driver.datesList, date] 
                                                } else {
                                                    driver.datesList = [date]
                                                }
                                            }
                                        })
                                    }
                                })
    
                                driverArray.forEach( driver => {
                                    finalObj[driver.location].push(driver)
                                })
                                let name = dateInner.toDateString()
                                let myObj = {}
                                myObj[`${name}`] = {
                                    'bottomArray': finalBottomArray,
                                    'drivers': finalObj
                                }
                                dispatch(addRota({
                                    payload: myObj[`${name}`],
                                    name: `${name}`
                                }))
                            })
                        }
                    }
                })
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.allGate])

    // onle one week
    // for grabbing all of the dates
    useEffect( () => {
        if (props.dateSelection) {
            if (reduxDrivers.length > 0) {
                let driverArray = [...reduxDrivers]
                let dateInner = props.dateSelection
                while (dateInner.getDay() !== 0) {
                    dateInner = new Date(dateInner.getFullYear(), dateInner.getMonth(), dateInner.getDate() - 1)
                }

                if (dateInner.getDay() === 0) {
                    let theDateWeek = new Date(dateInner).getWeek()
                    postData('https://backendpajamas.herokuapp.com/tripledates/', {
                        date: dateInner.toDateString(),
                        week: theDateWeek
                    }).then( response => {
                        let finalBottomArray = []
                        let finalObj = {
                            'DBS2': [],
                            'DCF1': [],
                            'DRR1': [],
                            'DEX2': [],
                            'DXP1': [],
                            'DSN1': []
                        }
                        let localDeleteArray = []
                        response.data.forEach( date => {
                            if (date.name === 'bottomRoutes') {
                                finalBottomArray.push(date)
                            } else {
                                driverArray.forEach( (driver, driverId) => {
                                    if (driver.driver_id === parseInt(date.driver_id.match(/\d+/g)[0])) {
                                        if (driver.datesList) {
                                            let localBool = true
                                            driver.datesList.forEach( innerDate => {
                                                if (innerDate.date === date.date) {
                                                    localDeleteArray.push(date)
                                                    localBool = false
                                                }
                                            })
                                            if (localBool) {
                                                let localDriver = {...driver}
                                                localDriver.datesList = [...localDriver.datesList, date]
                                                driverArray[driverId] = localDriver
                                            }
                                        } else {
                                            driver.datesList = [date]
                                        }
                                    }
                                })
                            }
                        })

                        driverArray.forEach( driver => {
                            finalObj[driver.location].push(driver)
                        })
                        let name = dateInner.toDateString()
                        let myObj = {}
                        myObj[`${name}`] = {
                            'bottomArray': finalBottomArray,
                            'drivers': finalObj
                        }
                        dispatch(addRota({
                            payload: myObj[`${name}`],
                            name: `${name}`
                        }))
                        if (localDeleteArray.length > 0) {
                            async function deleteData(url = '') {
                                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                                const response = await fetch(url, {
                                    method: 'Delete', 
                                    mode: 'cors',
                                    cache: 'no-cache',
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Token ${originalText}`
                                    },
                                });
                            };

                            localDeleteArray.forEach( date => {
                                deleteData(`https://backendpajamas.herokuapp.com/schedule/${date.date_id}/`)
                            })
                        }
                    })
                }
            } else {
                getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
                    let driverArray = response.results
                    let dateInner = props.dateSelection
                    while (dateInner.getDay() !== 0) {
                        dateInner = new Date(dateInner.getFullYear(), dateInner.getMonth(), dateInner.getDate() - 1)


                    }
                    if (dateInner.getDay() === 0) {
                        let theDateWeek = new Date(dateInner).getWeek()
                        postData('https://backendpajamas.herokuapp.com/tripledates/', {
                            date: dateInner.toDateString(),
                            week: theDateWeek
                        }).then( response => {
                            let finalBottomArray = []
                            let finalObj = {
                                'DBS2': [],
                                'DCF1': [],
                                'DRR1': [],
                                'DEX2': [],
                                'DXP1': [],
                                'DSN1': []
                        }
                            let datesToBeDeleted = []
                            response.data.forEach( date => {
                                if (date.name === 'bottomRoutes') {
                                    finalBottomArray.push(date)
                                } else {
                                    driverArray.forEach( driver => {
                                        if (driver.driver_id === parseInt(date.driver_id.match(/\d+/g)[0])) {
                                            if (driver.datesList) {
                                                let localBool = true
                                                driver.datesList.forEach( innerDate => {
                                                    if (innerDate.date === date.date) {
                                                        datesToBeDeleted.push(date)
                                                        localBool = false
                                                    }
                                                })
                                                if (localBool) {
                                                    driver.datesList = [...driver.datesList, date] 
                                                }
                                            } else {
                                                driver.datesList = [date]
                                            }
                                        }
                                    })
                                }
                            })

                            driverArray.forEach( driver => {
                                finalObj[driver.location].push(driver)
                            })
                            let name = dateInner.toDateString()
                            let myObj = {}
                            myObj[`${name}`] = {
                                'bottomArray': finalBottomArray,
                                'drivers': finalObj
                            }
                            dispatch(addRota({
                                payload: myObj[`${name}`],
                                name: `${name}`
                            }))
                            if (datesToBeDeleted.length > 0) {
                                async function deleteData(url = '') {
                                    let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                                    let originalText = bytes.toString(CryptoJS.enc.Utf8);
                                    const response = await fetch(url, {
                                        method: 'Delete', 
                                        mode: 'cors',
                                        cache: 'no-cache',
                                        credentials: 'same-origin',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': `Token ${originalText}`
                                        },
                                    });
                                };

                                datesToBeDeleted.forEach( date => {
                                    deleteData(`https://backendpajamas.herokuapp.com/schedule/${date.date_id}/`)
                                })
                            }
                        })
                    }
                })
            }
        }
    }, [props.dateSelection])

    return(
        <>
        </>
    )
}

export default GetSchedule